import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import resumeLogo from "../assets/grey_cv_background-removebg-preview.png";
import resumePdf from "../assets/Riyasat Ahmed .docx.pdf";
import linkedInLogo from "../assets/greylinkedin-removebg-preview.png";
import portraitImg from "../assets/riyasat-portrait.png";

const Hero = () => {
  const handleLinkedInClick = () => {
    window.open(
      "https://www.linkedin.com/in/riyasat-ahmed-81b31a316/",
      "_blank",
      "noopener,noreferrer"
    );
  };

  const handleResumeClick = () => {
    window.open(resumePdf, "_blank", "noopener,noreferrer");
  };

  return (
    <motion.section
      className="hero"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <motion.h2
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        Hi, I'm Riyasat Ahmed
      </motion.h2>

      <div className="hero-content">
        {/* Left: Portrait avatar (click opens LinkedIn) */}
        <motion.div
          className="hero-avatar"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.4, duration: 0.6 }}
        >
          <button
            type="button"
            className="hero-avatar-button"
            onClick={handleLinkedInClick}
            aria-label="Open LinkedIn profile"
          >
            <img
              src={portraitImg}
              alt="Riyasat Ahmed"
              className="hero-avatar-img"
            />
          </button>

          <div className="hero-quick-links" aria-label="Quick links">
            <button
              type="button"
              className="hero-quick-icon"
              onClick={handleLinkedInClick}
              aria-label="Open LinkedIn"
            >
              <img src={linkedInLogo} alt="LinkedIn" />
            </button>
            <button
              type="button"
              className="hero-quick-icon"
              onClick={handleResumeClick}
              aria-label="Open resume PDF"
            >
              <img src={resumeLogo} alt="Resume" />
            </button>
          </div>
        </motion.div>

        {/* Right: Text block */}
        <div className="hero-text-content">
          <motion.p
            className="hero-text"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.6, duration: 0.6 }}
          >
            Passionate about ingetrating automation and AI into everyday life. 
          </motion.p>

          <motion.p
            className="hero-degree"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.6 }}
          >
            University of Guelph • Honours Major Software Engineering <br/>
            Specialization in AI • Minor in Project Management
          </motion.p>

          <div className="hero-cta">
            <Link to="/projects" className="btn btn-primary">
              View Projects
            </Link>
            <Link to="/contact" className="btn btn-secondary">
              Contact Me
            </Link>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default Hero;
